import type { Ref } from 'vue'
import { CookieYes } from '$services/cookieyes'
import Category = CookieYes.Category

export namespace Listrak {

    export interface InitOptions {
        id: string
    }

    export class ListrakPlugin {
        private readonly id: string // JBG_LISTRAK_ID
        private ready: Ref<boolean> = ref(false)

        constructor(options: Listrak.InitOptions) {
            this.id = options.id
        }

        // Call setup once in layouts/default.vue
        public setup() {
            if (!this.isReady()) {
                const cookieConsentAdvertisement = CookieYes.hasConsent(Category.Advertisement)
                if (cookieConsentAdvertisement && this.id) {
                    const listrakScript = document.createElement('script')
                    listrakScript.setAttribute('src', `https://cdn.listrakbi.com/scripts/script.js?m=${this.id}&v=1`)
                    document.head.appendChild(listrakScript)
                    this.ready.value = true
                }
            }
        }

        public isReady(): boolean {
            return this.ready && this.ready.value
        }

        // Wrapper for Listrak's async listener in order to execute custom code
        // Defining this as a helper function means we only have to write this ugly copypasta once
        // See Listrak docs: https://help.listrak.com/en/articles/4820523-javascript-website-integration-installation
        public ltk(customHandler: (_ltk: any) => any) {
            if (!this.isReady) { return }
            (((d: () => void): void => {
                if (typeof _ltk === 'undefined') {
                    if (document.addEventListener) {
                        document.addEventListener('ltkAsyncListener', () => {
                            // eslint-disable-next-line no-underscore-dangle,camelcase
                            _ltk_util.ready(d)
                        })
                    } else {
                        const e = document.documentElement
                        e.ltkAsyncProperty = 0
                        e.attachEvent('onpropertychange', (e) => {
                            // eslint-disable-next-line eqeqeq
                            if (e.propertyName == 'ltkAsyncProperty') {
                                // eslint-disable-next-line no-underscore-dangle,camelcase
                                _ltk_util.ready(d)
                            }
                        })
                    }
                } else {
                    // eslint-disable-next-line no-underscore-dangle,camelcase
                    _ltk_util.ready(d)
                }
            })((): void => {
                /** ******** Begin Custom Code ********* */
                customHandler(_ltk)
                /** ******** End Custom Code *********** */
            }))
        }
    }

    export function install(key: string) {
        return new ListrakPlugin({ id: key })
    }
}


declare module '@vue/runtime-core' {
}
